"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const AdminRoleChanger_1 = require("./AdminRoleChanger");
const HelpNavItem_1 = require("./HelpNavItem");
const NavRightDropdown_1 = require("./NavRightDropdown");
const UserNavItem_1 = require("./UserNavItem");
const WorkspaceNavItem_1 = require("./WorkspaceNavItem");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const hooks_1 = require("../../../../hooks");
const react_2 = require("@osmosys/react");
const svg_1 = require("../../../../svg");
const react_if_1 = require("react-if");
exports.NavRight = () => {
    const { mode } = hooks_1.useOsmosysContext();
    const { history } = use_react_router_1.default();
    let navRight;
    const [isDropdownOpen, setIsDropdownOpen] = react_use_1.useBoolean(false);
    if (mode === 'anonymous') {
        navRight = (react_1.default.createElement(react_2.OsmosysTooltip, { label: "Osmosys is made by Yellow Brim" },
            react_1.default.createElement("a", { href: `https://yellowbrim.com/?ref=${window.location.hostname}`, target: "_blank", rel: "noopener noreferrer" },
                react_1.default.createElement(svg_1.YellowBrimLogo, { height: "1.5em", width: null, withText: true }))));
    }
    else if (mode === 'setup') {
        navRight = (react_1.default.createElement(reactstrap_1.NavItem, null,
            react_1.default.createElement(reactstrap_1.NavLink, { className: "text-muted disable-hover" }, "Account Setup")));
    }
    else if (mode === 'private') {
        navRight = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(WorkspaceNavItem_1.WorkspaceNavItem, { onWorkspaceChange: () => {
                    history.push('/');
                    window.location.reload();
                } }),
            react_1.default.createElement(UserNavItem_1.UserNavItem, null),
            react_1.default.createElement(AdminRoleChanger_1.AdminRoleChanger, null),
            react_1.default.createElement(HelpNavItem_1.HelpNavItem, null)));
    }
    return (react_1.default.createElement(reactstrap_1.Collapse, { isOpen: true, navbar: true },
        react_1.default.createElement(reactstrap_1.Nav, { className: "ml-auto", navbar: true },
            navRight,
            react_1.default.createElement(react_if_1.When, { condition: mode !== 'anonymous' }, () => (react_1.default.createElement(NavRightDropdown_1.NavRightDropdown, { isOpen: isDropdownOpen, onToggle: isOpen => {
                    setIsDropdownOpen(isOpen);
                } }))))));
};
//# sourceMappingURL=index.js.map